// Components - /components
import Live from "../live/";
import Table from "./components/table/table";
import ToolbarTabDays from "./components/toolbar-days";
import ToolbarTabSports from "./components/toolbar-sports";
import ToolbarTabMarkets from "./components/toolbar-markets";
import Carousel from "./components/carousel";
import Exceptional from "@/components/exceptional/exceptional";

import rulesOdds from "@/mixins/rulesOdds";
import Search from "@/components/search/search";

import MainEvents from "@/components/main-events";

export default {
  name: "events",
  mixins: [rulesOdds],
  components: {
    Table,
    ToolbarTabDays,
    ToolbarTabSports,
    ToolbarTabMarkets,
    Carousel,
    Live,
    Search,
    Exceptional,
    MainEvents,
  },
  data: () => {
    return {
      drawer: null,
      msg_error: "",
      loading: true,
      // Next Events
      next_events: [],
      data_events: [],
      id_sports: [],
      sport: "",
      n_days: null,
      _tabChangeTimeoutId: 0,
      motiveDialog: false,
    };
  },

  mounted() {
    const _this = this;
    this.getEvents(0, false);
    document.addEventListener("visibilitychange", function() {
      if (!document["hidden"]) {
        _this.getEvents(_this.n_days, false);
      }
    });
    const cacheEvents = this.$store.state.nextEvents;
    if (cacheEvents) {
      this.data_events = cacheEvents;
    }
    if (localStorage.getItem("p4fmotive") == "insufficient_balance") {
      this.$store.commit("setMotiveDialog", true);
      localStorage.removeItem("p4fmotive");
    }
  },

  computed: {
    getIdSport: function() {
      return this.$store.getters.getIdSportByName(this.$route.query.sport);
    },
  },
  methods: {
    // Emit
    filterBySports: async function(sport) {
      const eventsFiltredBySport = this.next_events.filter(
        (item) => item.id == sport.id
      )[0].categories;
      await this.editDataSports(eventsFiltredBySport);
      this.data_events = eventsFiltredBySport;
    },

    getEvents: function(n_days, userClick) {
      if (this.$route.path.includes("casino")) {
        return;
      }

      clearTimeout(this._tabChangeTimeoutId);

      this.n_days = n_days;

      this.loading = true;
      const objPost = {
        domain: this.$domain(),
        n_days,
      };
      this.$axios
        .post("/player/table/eventsByDay", this.$formdata(objPost))
        .then(async (resp) => {
          const { sports } = resp.data;
          this.next_events = sports;
          const objDataSports = new Object();
          for (const s of sports) {
            objDataSports[s.id] = s.categories;
          }

          await this.editDataSports(
            objDataSports[this.getIdSport] || objDataSports[6046]
          );

          this.$store.commit("nextEvents", objDataSports[this.getIdSport]);
          this.data_events = objDataSports[this.getIdSport];
          this.id_sports = Object.keys(objDataSports);

          ////////////////////
          // Special Sports //
          ///////////////////
          const specialSports = this.next_events.filter(
            (item) => item.id == 10
          );
          if (specialSports.length == 0) return;
          this.$store.commit("specialSports", specialSports);
        })
        .catch((error) => {
          this.data_events = undefined;
          error.response ? (this.msg_error = error.response.data.msg) : null;

          if (!userClick && this.days.length > n_days + 1) {
            this._tabChangeTimeoutId = setTimeout(() => {
              this.$root.$emit("advanceTab");
            }, 700);
          } else {
            clearTimeout(this._tabChangeTimeoutId);
          }
        })
        .finally(() => (this.loading = false));
    },
    updateDays(days) {
      this.days = days;
    },
  },
};
